package se.mittpass.web.components

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import se.mittpass.shared.api.AttendanceDto

@Composable
internal fun PliggarMonthView(
    anchor: String,
    recordsByDay: Map<String, List<AttendanceDto>>,
    isMobile: Boolean,
    onDayClick: (day: String) -> Unit
) {
    val (gridStart, _) = monthGridRange(anchor)
    val anchorMonth = anchor.split("-")[1].toInt()
    val today = todayLocalDate()
    val maxPills = if (isMobile) 1 else 2
    val cellMinHeight = if (isMobile) "72px" else "108px"

    Div({ style {
        property("display", "grid")
        property("grid-template-columns", "repeat(7, 1fr)")
        property("gap", "1px")
        property("background", "var(--rp-overlay)")
        property("border-radius", "12px")
        property("overflow", "hidden")
        property("border", "1px solid var(--rp-hl-med)")
    } }) {
        for (i in 0..6) {
            Div({ style {
                property("background", "var(--rp-surface)"); property("padding", "0.5rem")
                property("font-size", "0.7rem"); property("font-weight", "700")
                property("color", "var(--rp-muted)"); property("text-transform", "uppercase")
                property("letter-spacing", "0.8px"); property("text-align", "center")
            } }) { Text(DAY_NAMES_SHORT[i]) }
        }

        for (idx in 0 until 42) {
            val cellDate = addDays(gridStart, idx)
            val parts = cellDate.split("-")
            val cellMonth = parts[1].toInt()
            val dayNum = parts[2].toInt()
            val isOtherMonth = cellMonth != anchorMonth
            val isToday = cellDate == today
            val dayRecs = recordsByDay[cellDate].orEmpty()

            Div({
                onClick { onDayClick(cellDate) }
                style {
                    property("background", if (isOtherMonth) "var(--rp-surface)" else "var(--rp-surface)")
                    property("padding", "0.4rem 0.45rem")
                    property("min-height", cellMinHeight); property("cursor", "pointer")
                    property("display", "flex"); property("flex-direction", "column"); property("gap", "0.25rem")
                    property("position", "relative")
                }
            }) {
                Div({ style {
                    property("display", "flex"); property("align-items", "center")
                    property("justify-content", "space-between")
                } }) {
                    Span({ style {
                        property("display", "inline-flex"); property("align-items", "center"); property("justify-content", "center")
                        property("min-width", "22px"); property("height", "22px"); property("border-radius", "50%")
                        property("font-size", "0.78rem"); property("font-weight", "700")
                        if (isToday) {
                            property("background", "var(--rp-pine)"); property("color", "var(--rp-surface)"); property("padding", "0 0.4rem")
                        } else {
                            property("color", if (isOtherMonth) "var(--rp-hl-med)" else "var(--rp-text)")
                        }
                    } }) { Text(dayNum.toString()) }
                    if (dayRecs.isNotEmpty()) {
                        Span({ style {
                            property("font-size", "0.65rem"); property("font-weight", "600"); property("color", "var(--rp-muted)")
                        } }) { Text("${dayRecs.size}") }
                    }
                }

                val visible = dayRecs.take(maxPills)
                visible.forEach { rec ->
                    val name = listOfNotNull(rec.firstName, rec.lastName).joinToString(" ")
                        .ifEmpty { rec.userEmail.substringBefore("@") }
                    val complete = rec.checkOutTime != null
                    Div({ style {
                        property("display", "flex"); property("align-items", "center"); property("gap", "0.3rem")
                        property("padding", "0.15rem 0.4rem"); property("border-radius", "6px")
                        property("font-size", "0.7rem"); property("font-weight", "600")
                        property("white-space", "nowrap"); property("overflow", "hidden"); property("text-overflow", "ellipsis")
                        if (complete) {
                            property("background", "var(--rp-ok-bg)"); property("color", "var(--rp-pine)")
                        } else {
                            property("background", "var(--rp-err-bg)"); property("color", "var(--rp-love)")
                        }
                        if (isOtherMonth) property("opacity", "0.65")
                    } }) {
                        Span({ style {
                            property("width", "5px"); property("height", "5px"); property("border-radius", "50%")
                            property("background", if (complete) "var(--rp-pine)" else "var(--rp-love)"); property("flex-shrink", "0")
                        } }) {}
                        Text(name)
                    }
                }
                if (dayRecs.size > maxPills) {
                    Div({ style {
                        property("font-size", "0.65rem"); property("font-weight", "700")
                        property("color", "var(--rp-subtle)"); property("padding", "0.1rem 0.4rem"); property("cursor", "pointer")
                    } }) { Text("+${dayRecs.size - maxPills} fler") }
                }
            }
        }
    }
}
